import { css } from '@emotion/react';
import { Theme } from '../../config/theme';

export default (theme: Theme) => ({
  radioInput: css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    padding: 0;
    background-color: transparent;
    border: none;
    &:hover {
      text-decoration: underline;
    }
  `,
  selectedIndicator: css`
    width: 3rem;
    height: 3rem;
    border-radius: 100%;
    border: 2px solid ${theme.color.border};
    background-color: transparent;
  `,
  selected: css`
    background-color: ${theme.color.button};
  `,
});
